/* ====================================================================
   MOCK DATA — preview only (no API calls)
   Domestic trucking (GCS pilot): full-truckload lanes, dry van / reefer.
   ==================================================================== */

export const INITIAL_SHIPMENTS = [
  {
    id: 'SHP-00424',
    status: 'DRAFT',
    needsAttention: true,
    createdAt: '2026-06-04T11:30:00Z',
    createdBy: 'aaron@marteu.com',
    route: {
      origin: { code: 'SAV', name: 'Savannah, GA', country: 'US' },
      destination: { code: 'MEM', name: 'Memphis, TN', country: 'US' }
    },
    mode: 'FTL · Dry van',
    cargo: {},
    commercial: {},
    commodity: {},
    readyDate: '2026-06-12',
    activity: [
      { id: 'm1', kind: 'system', text: 'Shipment created · Savannah, GA → Memphis, TN · FTL dry van · Pickup Jun 12' },
      { id: 'm2', kind: 'message', role: 'ai', author: 'Marq',
        text: "Got it — Savannah, GA to Memphis, TN, full truckload dry van, pickup Jun 12. To send rate requests I just need the cargo: pallet count, total weight, and what's on it." },
      { id: 'm3', kind: 'message', role: 'customer', author: 'You',
        text: '22 pallets, about 40,000 lbs.' },
      { id: 'm4', kind: 'message', role: 'ai', author: 'Marq',
        text: "Got 22 pallets at ~40,000 lbs. One thing left — what's the commodity? (Even a category like 'packaged food' or 'building materials' is enough to start.)" }
    ],
    providers: [],
    timeline: [
      { date: 'Jun 4', label: 'Created' },
      { date: 'Jun 4', label: 'Awaiting cargo info', current: true }
    ]
  },
  {
    id: 'SHP-00421',
    userName: 'Macon → Baton Rouge · dry van',
    status: 'DECIDE',
    needsAttention: true,
    createdAt: '2026-06-05T09:00:00Z',
    createdBy: 'aaron@marteu.com',
    route: {
      origin: { code: 'MCN', name: 'Macon, GA', country: 'US' },
      destination: { code: 'BTR', name: 'Baton Rouge, LA', country: 'US' }
    },
    mode: 'FTL · Dry van',
    cargo: {
      palletCount: 24,
      dims: '48×40 std',
      totalWeight: 42000
    },
    commercial: { incoterm: null },
    commodity: { description: 'Palletized retail goods' },
    readyDate: '2026-06-08',
    activity: [
      { id: 'm1', kind: 'system', text: 'Shipment created · Macon, GA → Baton Rouge, LA · FTL dry van · Pickup Jun 8' },
      { id: 'm2', kind: 'message', role: 'ai', author: 'Marq',
        text: "Got it — Macon, GA to Baton Rouge, LA, full truckload dry van, pickup Jun 8. I'll send rate requests to your usual carriers on this lane plus a couple of backups." },
      { id: 'm3', kind: 'message', role: 'customer', author: 'You',
        text: '24 pallets, ~42,000 lbs, palletized retail goods. Go ahead.' },
      { id: 'm4', kind: 'message', role: 'ai', author: 'Marq',
        text: "Sending rate requests to 5 carriers — GLB Logistics, PGT Trucking, RoadEx, Sunbelt, and PLS Logistics." },
      { id: 'm5', kind: 'system', text: 'RFQ sent to GLB Logistics · Jun 5, 09:01' },
      { id: 'm6', kind: 'system', text: 'RFQ sent to PGT Trucking · Jun 5, 09:01' },
      { id: 'm7', kind: 'system', text: 'RFQ sent to RoadEx · Jun 5, 09:02' },
      { id: 'm8', kind: 'system', text: 'RFQ sent to Sunbelt · Jun 5, 09:02' },
      { id: 'm9', kind: 'system', text: 'RFQ sent to PLS Logistics · Jun 5, 09:02' },
      { id: 'm10', kind: 'message', role: 'ai', author: 'Marq',
        text: "Done. Watching for rates — typical turnaround on this lane is 1–4 hours." },
      { id: 'm11', kind: 'system', text: 'Rate received from GLB Logistics · Jun 5, 11:20' },
      { id: 'm12', kind: 'system', text: 'Rate received from PGT Trucking · Jun 5, 12:05' },
      { id: 'm13', kind: 'system', text: 'Rate received from RoadEx · Jun 5, 13:40' },
      { id: 'm14', kind: 'system', text: 'Rate received from Sunbelt · Jun 5, 14:10' },
      { id: 'm15', kind: 'message', role: 'ai', author: 'Marq',
        text: "4 of 5 carriers responded — PLS hasn't replied yet. I've normalized and compared them below." },
      // Anchor for the comparison table: ActivityLog suppresses this item and
      // renders the table in its place, so anything appended later (e.g. the
      // share conversation with Marq) shows BELOW the table.
      { id: 'm16', kind: 'compare' }
    ],
    // Provider rows feed ProviderComparisonCard directly in the preview (in prod
    // these come from deriveProviders). Sunbelt is the untrusted-underbidder
    // case: cheapest on price, but flagged below-cluster + low-confidence.
    // RoadEx quoted base-only (no fuel line) — not truly apples-to-apples.
    providers: [
      { id: 'pv-glb', quoteId: 'q-glb', name: 'GLB Logistics', status: 'received',
        cost: 1400, currency: 'USD', days: 2, fuel: 210, equipment: 'Dry van', validUntil: '2026-06-06',
        breakdown: [
          ['Linehaul', '$1,190'],
          ['Fuel surcharge', '$210']
        ],
        terms: [
          ['Rate type', 'All-in'],
          ['Equipment', 'Dry van 53 ft'],
          ['Pickup', 'Jun 8'],
          ['Delivery', 'Jun 10']
        ],
        rawReply: 'Can cover Macon to Baton Rouge. $1,400 all-in incl. fuel. Dry van, pickup Jun 8, deliver Jun 10 (2 days). Rate good through Jun 6.',
        sourceDoc: 'GLB_Rate_Macon_BatonRouge.pdf',
        // Value-back to sales: carrier contact + accumulated insights.
        contact: { name: 'Dana Brooks', email: 'dispatch@glblogistics.com', phone: '+1 (478) 555-0143' },
        insights: { rating: 4.7, onTimePct: 96, loads: 52 } },
      { id: 'pv-pgt', quoteId: 'q-pgt', name: 'PGT Trucking', status: 'received',
        cost: 1500, currency: 'USD', days: 2, fuel: 235, equipment: 'Dry van', validUntil: '2026-06-09',
        breakdown: [
          ['Linehaul', '$1,265'],
          ['Fuel surcharge', '$235']
        ],
        terms: [
          ['Rate type', 'All-in'],
          ['Equipment', 'Dry van 53 ft'],
          ['Pickup', 'Jun 8']
        ],
        rawReply: 'PGT can do it. $1,500 all-in. Dry van, pickup Jun 8, about 2 days transit. Valid through Jun 9.',
        contact: { name: 'Marcus Hill', email: 'ops@pgttrucking.com', phone: '+1 (724) 555-0119' },
        insights: { rating: 4.4, onTimePct: 92, loads: 31 } },
      { id: 'pv-roadex', quoteId: 'q-roadex', name: 'RoadEx', status: 'received',
        cost: 1420, currency: 'USD', days: 3, fuel: null, equipment: 'Dry van', validUntil: '2026-06-06',
        terms: [
          ['Rate type', 'Base only'],
          ['Equipment', 'Dry van 53 ft']
        ],
        rawReply: 'base rate 1420 for the lane. fuel not included, will advise FSC at dispatch. dry van, 3 days.',
        contact: { name: 'Priya Nair', email: 'quotes@roadex.com', phone: '+1 (901) 555-0177' },
        insights: { rating: 4.1, onTimePct: 88, loads: 19 } },
      { id: 'pv-sunbelt', quoteId: 'q-sunbelt', name: 'Sunbelt', status: 'received',
        cost: 935, currency: 'USD', days: 2, fuel: 120, equipment: 'Dry van', validUntil: null,
        confidence: 'LOW',
        terms: [['Rate type', 'All-in']],
        rawReply: 'we got a truck near macon, can do 935 all in. 2 days. lmk asap',
        contact: { name: 'Rick Tann', email: 'rick@sunbeltcarrier.co', phone: '' },
        insights: { rating: 3.6, onTimePct: 79, loads: 4 } },
      { id: 'pv-pls', name: 'PLS Logistics', status: 'pending' }
    ],
    timeline: [
      { date: 'Jun 5', label: 'Created' },
      { date: 'Jun 5', label: 'RFQs sent' },
      { date: 'Jun 5', label: '4 of 5 in', current: true }
    ]
  },
  {
    id: 'SHP-00419',
    userName: 'Laredo cross-dock',
    status: 'RFQS_SENT',
    needsAttention: false,
    createdAt: '2026-06-03T09:15:00Z',
    createdBy: 'aaron@marteu.com',
    route: {
      origin: { code: 'LRD', name: 'Laredo, TX', country: 'US' },
      destination: { code: 'CHI', name: 'Chicago, IL', country: 'US' }
    },
    mode: 'FTL · Dry van',
    cargo: { palletCount: 26, dims: '48×40 std', totalWeight: 44000 },
    commercial: { incoterm: null },
    commodity: { description: 'Auto parts' },
    readyDate: '2026-06-11',
    activity: [
      { id: 'm1', kind: 'system', text: 'Shipment created · Laredo, TX → Chicago, IL · FTL dry van · Pickup Jun 11' },
      { id: 'm2', kind: 'message', role: 'ai', author: 'Marq',
        text: "Laredo, TX to Chicago, IL, full truckload, 44,000 lbs of auto parts. Long haul — I'll pull carriers with a solid I-55 corridor record." },
      { id: 'm3', kind: 'provider_selection',
        suggestedCount: 3,
        tenantMedianCount: 3,
        quoteType: 'domestic_trucking',
        candidates: [
          { providerId: 'pv1', name: 'GLB Logistics', score: 93, suggested: true, rationale: '93/100 — best lane fit + fastest rate turnaround (avg 2h)' },
          { providerId: 'pv2', name: 'PGT Trucking', score: 89, suggested: true, rationale: '89/100 — strong I-55 corridor history, reliable van capacity' },
          { providerId: 'pv3', name: 'RoadEx', score: 80, suggested: true, rationale: '80/100 — 4 successful TX→IL loads this quarter' },
          { providerId: 'pv4', name: 'PLS Logistics', score: 64, suggested: false, rationale: '64/100 — available but slow to respond lately' }
        ]
      }
    ],
    providers: [],
    timeline: [
      { date: 'Jun 3', label: 'Created' },
      { date: 'Jun 3', label: 'Carrier selection', current: true }
    ]
  },
  {
    id: 'SHP-00415',
    userName: 'Newark → Atlanta reefer',
    status: 'BOOKED',
    needsAttention: false,
    createdAt: '2026-05-28T16:00:00Z',
    createdBy: 'aaron@marteu.com',
    route: {
      origin: { code: 'EWR', name: 'Newark, NJ', country: 'US' },
      destination: { code: 'ATL', name: 'Atlanta, GA', country: 'US' }
    },
    mode: 'FTL · Reefer',
    cargo: { palletCount: 20, dims: '48×40 std', totalWeight: 38000 },
    commercial: { incoterm: null },
    commodity: { description: 'Refrigerated foods' },
    readyDate: '2026-06-01',
    activity: [
      { id: 'm1', kind: 'system', text: 'Shipment created · Newark, NJ → Atlanta, GA · FTL reefer · Pickup Jun 1' },
      { id: 'm2', kind: 'message', role: 'ai', author: 'Marq',
        text: "Newark, NJ to Atlanta, GA, full truckload reefer, 38,000 lbs refrigerated foods. I'll pull carriers with reefer capacity and a clean temp-compliance record." },
      { id: 'm3', kind: 'system', text: 'RFQ sent to Coastal Freight · May 28' },
      { id: 'm4', kind: 'system', text: 'RFQ sent to Midwest Carriers · May 28' },
      { id: 'm5', kind: 'system', text: 'RFQ sent to Sunbelt · May 28' },
      { id: 'm6', kind: 'system', text: 'Rate received from Coastal Freight · May 29' },
      { id: 'm7', kind: 'system', text: 'Rate received from Midwest Carriers · May 29' },
      { id: 'm8', kind: 'system', text: 'Sunbelt declined — no reefer available · May 29' },
      { id: 'm9', kind: 'message', role: 'customer', author: 'You',
        text: 'Go with Coastal Freight.' },
      { id: 'm10', kind: 'message', role: 'ai', author: 'Marq',
        text: "Booking Coastal Freight — $2,150 all-in, reefer at 34°F, pickup Jun 1, deliver Jun 3." },
      { id: 'm11', kind: 'booking', provider: 'Coastal Freight',
        containerNo: 'CFRU-204815', cutoff: 'Jun 1, 2026' }
    ],
    providers: [
      { id: 'pv-coastal', quoteId: 'q-coastal', name: 'Coastal Freight', status: 'selected',
        cost: 2150, currency: 'USD', days: 2, fuel: 320, equipment: 'Reefer', validUntil: '2026-06-02',
        terms: [
          ['Rate type', 'All-in'],
          ['Equipment', 'Reefer 53 ft @ 34°F'],
          ['Pickup', 'Jun 1'],
          ['Delivery', 'Jun 3']
        ],
        rawReply: 'Confirmed $2,150 all-in incl. fuel. Reefer set to 34F, pickup Jun 1, deliver Jun 3 (2 days). Valid through Jun 2.',
        sourceDoc: 'Coastal_Rate_EWR_ATL.pdf',
        contact: { name: 'Lena Ortiz', email: 'dispatch@coastalfreight.com', phone: '+1 (973) 555-0151' },
        insights: { rating: 4.5, onTimePct: 93, loads: 22 } },
      { id: 'pv-midwest', quoteId: 'q-midwest', name: 'Midwest Carriers', status: 'received',
        cost: 2380, currency: 'USD', days: 2, fuel: 360, equipment: 'Reefer', validUntil: '2026-06-03',
        terms: [
          ['Rate type', 'All-in'],
          ['Equipment', 'Reefer 53 ft'],
          ['Pickup', 'Jun 1']
        ],
        rawReply: '$2,380 all-in, reefer, pickup Jun 1, ~2 days. Valid Jun 3.',
        contact: { name: 'Sam Powell', email: 'ops@midwestcarriers.com', phone: '+1 (312) 555-0166' },
        insights: { rating: 4.2, onTimePct: 90, loads: 17 } },
      { id: 'pv-sunbelt-2', name: 'Sunbelt', status: 'declined',
        declinedReason: 'No reefer capacity on this lane for the pickup window.' }
    ],
    timeline: [
      { date: 'May 28', label: 'Created' },
      { date: 'May 29', label: 'Booked' },
      { date: 'Jun 3', label: 'Delivered', current: true }
    ]
  }
]

// Quote-flow lifecycle. The product stops at quote selection / booking, so
// states beyond BOOKED (in-transit / delivered) don't live here.
export const STATUS_LABELS = {
  DRAFT:        'Draft',
  RFQS_SENT:    'RFQs sent',
  PARTIAL:      null,         // dynamic — see getStatusLabel ("2 of 3")
  NEEDS_REPLY:  'Needs Reply',
  DECIDE:       'Review quotes',
  BOOKED:       'Booked'
}
